import { type Metric } from '../vessel_data'

export enum TankMetric {
  tankBallastWater1 = 'tankBallastWater1',
  tankBallastWater2 = 'tankBallastWater2',
  tankBallastWater3 = 'tankBallastWater3',
  tankBallastWater4 = 'tankBallastWater4',
  tankBallastWater5 = 'tankBallastWater5',
  tankBallastWater6 = 'tankBallastWater6',
  tankBallastWater7 = 'tankBallastWater7',
  tankBallastWater8 = 'tankBallastWater8',
  tankBallastWater9 = 'tankBallastWater9',
  tankBallastWater10 = 'tankBallastWater10',
  tankFreshWater1 = 'tankFreshWater1',
  tankFreshWater2 = 'tankFreshWater2',
  tankFreshWater3 = 'tankFreshWater3',
  tankFreshWater4 = 'tankFreshWater4',
  tankFreshWater5 = 'tankFreshWater5',
  tankFreshWater6 = 'tankFreshWater6',
  tankFreshWater7 = 'tankFreshWater7',
  tankFreshWater8 = 'tankFreshWater8',
  tankFreshWater9 = 'tankFreshWater9',
  tankFreshWater10 = 'tankFreshWater10',
  tankPoolWater1 = 'tankPoolWater1',
  tankPoolWater2 = 'tankPoolWater2',
  tankPoolWater3 = 'tankPoolWater3',
  tankPoolWater4 = 'tankPoolWater4',
  tankPoolWater5 = 'tankPoolWater5',
  tankPoolWater6 = 'tankPoolWater6',
  tankPoolWater7 = 'tankPoolWater7',
  tankPoolWater8 = 'tankPoolWater8',
  tankPoolWater9 = 'tankPoolWater9',
  tankPoolWater10 = 'tankPoolWater10',
  tankFuel1 = 'tankFuel1',
  tankFuel2 = 'tankFuel2',
  tankFuel3 = 'tankFuel3',
  tankFuel4 = 'tankFuel4',
  tankFuel5 = 'tankFuel5',
  tankFuel6 = 'tankFuel6',
  tankFuel7 = 'tankFuel7',
  tankFuel8 = 'tankFuel8',
  tankFuel9 = 'tankFuel9',
  tankFuel10 = 'tankFuel10'
}

export type TankMetricName = keyof typeof TankMetric

export type TankMetrics = Record<TankMetricName, Metric>

export const allTankMetricNames: TankMetricName[] = Object.values(TankMetric)
